import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-details-popup',
  templateUrl: './user-details-popup.component.html',
  styleUrls: ['./user-details-popup.component.css']
})
export class UserDetailsPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
